var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from "react";
import gql from "graphql-tag";
import { merge } from "lodash";
import uuidv4 from "uuid/v4";
import authentication from "@irati/auth";
import { Mutation } from "../";
import { query as messagesQuery } from "../../query/Chatroom/Messages";
import { messageFieldsFragment } from "../../gql/fragments/message";
var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation CreateInsMessage($params: InsMessageCreateInput!) {\n    createInsMessage(params: $params){\n      ...messageFields\n    }\n  }\n  ", "\n"], ["\n  mutation CreateInsMessage($params: InsMessageCreateInput!) {\n    createInsMessage(params: $params){\n      ...messageFields\n    }\n  }\n  ", "\n"])), messageFieldsFragment);
var CreateMessageAnonChat = function (_a) {
    var children = _a.children, tenantProp = _a.tenantUuid, roomUuid = _a.roomUuid, text = _a.text, isUserAnonymous = _a.isUserAnonymous, props = __rest(_a, ["children", "tenantUuid", "roomUuid", "text", "isUserAnonymous"]);
    var tenantUuid = tenantProp || authentication.userTenant().uuid;
    var uuid = uuidv4();
    var variables = { params: { tenantUuid: tenantUuid, roomUuid: roomUuid, text: text, uuid: uuid } };
    var optimisticResponse = {
        __typename: "Mutation",
        createInsMessage: {
            __typename: "InsMessage",
            uuid: uuid,
            text: text,
            createdAt: null,
            roomUuid: roomUuid,
            userUuid: isUserAnonymous ? null : authentication.user().uuid,
            user: isUserAnonymous ? null : __assign({ __typename: "User" }, authentication.user())
        }
    };
    var update = function (proxy, _a) {
        var createInsMessage = _a.data.createInsMessage;
        var query = { query: messagesQuery, variables: { params: { tenantUuid: tenantUuid, roomUuid: roomUuid } } };
        var insMessages = proxy.readQuery(query).insMessages;
        proxy.writeQuery(__assign(__assign({}, query), { data: {
                insMessages: __assign(__assign({}, insMessages), { results: __spreadArrays(insMessages.results, [createInsMessage]) })
            } }));
    };
    var optimisticUi = roomUuid ? { optimisticResponse: optimisticResponse, update: update } : {};
    return (React.createElement(Mutation, __assign({ mutation: mutation, variables: variables }, props), function (mutate, apolloState) {
        return children(function (args) { return mutate(merge(args, __assign({ variables: variables }, optimisticUi))); }, apolloState);
    }));
};
export default CreateMessageAnonChat;
var templateObject_1;
